import { CustomDataTableWizard } from 'components/customDataTableWizard'
import { LoadingContainer } from 'components/loadingContainer'
import { useLocationsWizard } from 'hooks/admin/useLocations'
import React, { Dispatch } from 'react'

import { LocationForm } from '../form'
import { FormContainer, FormTitle } from '../locations.style'

interface Props {
    onSuccess?: () => void
    selectedRow: any
    setSelectedRow: Dispatch<any>
    formRef?: React.RefObject<HTMLFormElement>
    eventId?: string
    partnerId?: string
}

export const LocationsTableWizard: React.FC<Props> = ({ onSuccess, selectedRow, setSelectedRow, formRef, eventId, partnerId }) => {
    const { currentAccount, eventLocations, dataToDisplay, isLoading, error, tableConfig } = useLocationsWizard({
        selectedRow,
        eventId,
        partnerId,
    })

    const handleRowClick = (rowData: any) => setSelectedRow(rowData)
    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            {eventLocations && currentAccount && (
                <CustomDataTableWizard
                    tableConfig={tableConfig}
                    data={eventLocations}
                    selectedRow={selectedRow}
                    handleRowClick={handleRowClick}
                />
            )}
            {selectedRow && (
                <>
                    <FormTitle>Helyszín testreszabása</FormTitle>
                    <FormContainer>
                        <LocationForm
                            initialData={dataToDisplay}
                            onSuccess={onSuccess}
                            formRef={formRef}
                            eventLocation={true}
                            eventId={eventId}
                            partnerId={partnerId}
                        />
                    </FormContainer>
                </>
            )}
        </LoadingContainer>
    )
}
